import React from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
} from "react-native";
const { width, height } = Dimensions.get("window");
export default function bottomSection() {
  return (
    <View
      style={{
        width: width,
        height: 83,
        backgroundColor: "#FFFFFF",
        justifyContent: "center",
        zIndex: 999,
        alignSelf: "flex-end",
      }}
    >
      <Text
        style={{
          fontSize: 20,
          fontFamily: "Prompt",
          color: "#2B6AB1",
          alignSelf: "center",
        }}
      >
        Copyright © AAA
      </Text>
    </View>
  );
}
const styles = StyleSheet.create({});
